import { TranslocoPipe } from '@jsverse/transloco';
import { Component, Input, OnInit } from '@angular/core';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { ListPageColumnComponent } from 'design-system';
import { orderTagTone } from '../../utils/order.utils';

// Tag dell'ordine con i colori del Flutter; come cella di tabella prende il valore della colonna e, con più sotto-ordini,
// al click apre il tooltip con lo stato di ognuno
@Component({
  selector: 'ord-order-status-badge',
  imports: [TranslocoPipe, MatTooltipModule],
  template: `
    @if (tag) {
      <span class="order-status-badge body-medium-emphasized" [class]="'order-status-badge--' + tone"
        [class.order-status-badge--sub-orders]="!!subOrders" [matTooltip]="subOrders" [matTooltipDisabled]="!subOrders"
        matTooltipClass="order-status-badge-tooltip" matTooltipPosition="below" #tooltip="matTooltip"
        (click)="showSubOrders($event, tooltip)">{{ tag.startsWith('orders.ui.') ? (tag | transloco) : tag }}</span>
    }
  `,
  styleUrl: './order-status-badge.scss',
})
export class OrderStatusBadge extends ListPageColumnComponent implements OnInit {
  @Input() tag = '';
  @Input() subOrders = '';

  get tone(): string {
    return orderTagTone(this.tag);
  }

  ngOnInit(): void {
    if (this.itemData && this.infoColumn) {
      this.tag = this.itemData[this.infoColumn.columnNameDef];
      this.subOrders = this.itemData['sottoOrdini'] ?? '';
    }
  }

  // Il click sul badge apre il tooltip anche al tocco e non apre il dettaglio della riga
  showSubOrders(event: Event, tooltip: MatTooltip): void {
    if (!this.subOrders) {
      return;
    }

    event.stopPropagation();
    tooltip.show();
  }
}
